export default "__VITE_ASSET__CiQSP6hL__"